import React, { Component,useEffect } from 'react';
import Header from './Header';
import App from '../App';
const Home = () => {

useEffect(() => {
  sessionStorage.clear();

  
} );
 
const url = window.location.href;
 //const url = "ulsterbank1";
        return (
          <div>{
             (() => {
           if(url.includes("ulsterbank")) {
            return (
              <> <><App/></> </>
            )
            }else {
              return (
                <><App /> </>
              )
            }
          })() 
        }
        </div>
        )}


export default Home;